<template>   
<div>     <footer class="footer" :class="{ hidden: hidden }">       
<div class="footer_content">         
<div class="footer-info">           
<div class="footer-link">             <a v-for="item in menu" :key="item.id" @click="goTo(item)">{{ item.menuName }}</a>           
</div>           
<div class="footer-friendly">             
<div class="friendly-link" v-for="item in link" :key="item.id" @click="openLink(item)" :title="item.linkName">               <img :src="item.linkPic" alt="" />               {{ item.linkName }}             
</div>           
</div>         
</div>         
<div class="footer-filings">           <span>{{ info.copyright }}</span>           <span v-html="info.icp"></span>         
</div>       
</div>     </footer>     
<div :class="{ pt30: hidden }">
</div>   
</div> </template>

<script>
import { getSite, getBottomMenu, getLinkList } from '@/api/home'
export default {
  name: 'bottomFooter',
  props: {},
  data() {
    return {
      info: {},
      link: {},
      menu: {},
      hidden: false
    }
  },
  created() {
    this.getInfo()
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.hidden = val.name === 'bookPreview' ? true : false
      }
    }
  },
  methods: {
    getInfo() {
      getSite().then((res) => {
        this.info = res.data
        this.$store.dispatch('app/setToolbar', res.data)
      })
      getBottomMenu().then((res) => {
        this.menu = res.data
        this.$store.dispatch('setLink', this.menu)
      })
      getLinkList().then((res) => {
        this.link = res.data
      })
    },
    openLink(item) {
      window.open(item.linkUrl)
    },
    goTo(item) {
      this.$router.push({
        name: item.path,
        query: {
          menuId: item.menuId,
          contentType: item.contentType,
          menuName: item.menuName,
          parentId: item.parentId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  color: #b4b7ba;
  text-align: left;
  background-image: url('../../assets/images/bottom.png');
  background-size: 100% 100%;
  min-width: 1200px;
  .footer-info {
    display: flex;
    align-items: center;
    height: 115px;
    font-size: 12px;
    padding-top: 25px;

    .footer-link {
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      margin-right: 10%;
      // justify-content: space-between;
      justify-content: flex-start;
      a {
        cursor: pointer;
        color: #ffffff;
        text-decoration: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 120px;
        margin-right: 80px;
        &:nth-last-child(1) {
          margin-right: 0;
        }
      }
    }
    .footer-friendly {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      min-width: 200px;
      max-width: 400px;
      font-size: 14px;
      .link-title {
        position: absolute;
        top: 0;
      }
      .friendly-link {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 30px;
        //max-width: 150px;
        color: #ffffff;
        cursor: pointer;
        img {
          //width: 30px;
          height: 30px;
          vertical-align: middle;
        }
        &:nth-last-child(1) {
          margin-right: 0;
        }
      }
    }
  }
  .footer_content {
    height: 100%;
    padding: 0 calc((100% - 1200px) / 2);
    .footer-filings {
      display: flex;
      height: 57px;
      align-items: center;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      font-size: 12px;
      span a,
      span {
        margin-left: 5px;
        color: rgba(255, 255, 255, 0.8) !important;
        text-decoration: none;
      }
      span:first-child {
        margin-left: 0;
      }
    }
  }
}
.hidden {
  display: none;
}
.pt30 {
  padding-top: 26px;
}
</style>
